import React from 'react';
type CtaButtonProps = {
  label: string;
  href?: string;
  onClick?: () => void;
  showGuarantee?: boolean;
};
const buttonClass = 'block w-full rounded-lg bg-gold py-[18px] px-4 text-center font-sans text-[15px] font-bold uppercase tracking-wide text-ink shadow-gold transition-transform duration-150 ease-out hover:scale-[1.02] active:scale-[1.02] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-ink';
export function CtaButton({
  label,
  href,
  onClick,
  showGuarantee = true
}: CtaButtonProps) {
  return <div className="w-full" data-id="element-39" data-mp="10a3plz45f4ug">
      {href ? <a href={href} className={buttonClass} data-id="element-40" data-mp="109u00cn0mzpa">
          {label}
        </a> : <button type="button" onClick={onClick} className={buttonClass} data-id="element-41" data-mp="vcldy0yqybir">
          {label}
        </button>}
      {showGuarantee && <p className="mt-3 text-center text-xs text-muted/70" data-id="element-42" data-mp="198p8xwhg2nwa">
          Garantía de 7 días · Pago seguro con Hotmart
        </p>}
    </div>;
}